export interface IGetAge {
	year: string;
	month?: string;
	day?: string;
}

export default function getAge({ year, month, day }: IGetAge): number {
	const yearAsNumber = parseInt(year) || 0;
	const currentTime = new Date();
	const currentYear = currentTime.getFullYear();

	if (month) {
		const monthAsNumber = parseInt(month) || 0;
		const currentMonth = currentTime.getMonth() + 1;
		if (monthAsNumber > currentMonth) {
			return currentYear - yearAsNumber - 1;
		}
		if (monthAsNumber < currentMonth) {
			return currentYear - yearAsNumber;
		}
		if (monthAsNumber === currentMonth) {
			if (day) {
				const dayAsNumber = parseInt(day) || 0;
				const currentDay = currentTime.getDate();
				if (dayAsNumber <= currentDay) {
					return currentYear - yearAsNumber;
				}
				return currentYear - yearAsNumber - 1;
			}
		}
	}
	return currentYear - yearAsNumber;
}
